"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceConfigurationBackupApi = exports.ServiceConfigurationBackupApiFactory = exports.ServiceConfigurationBackupApiFp = exports.ServiceConfigurationBackupApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * ServiceConfigurationBackupApi - axios parameter creator
 * @export
 */
const ServiceConfigurationBackupApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} configId
         * @param {string} serviceId
         * @param {string} serviceType
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceConfigurationBackupResourceAddBackup: (configId_1, serviceId_1, serviceType_1, body_1, ...args_1) => __awaiter(this, [configId_1, serviceId_1, serviceType_1, body_1, ...args_1], void 0, function* (configId, serviceId, serviceType, body, options = {}) {
            // verify required parameter 'configId' is not null or undefined
            (0, common_1.assertParamExists)('serviceConfigurationBackupResourceAddBackup', 'configId', configId);
            // verify required parameter 'serviceId' is not null or undefined
            (0, common_1.assertParamExists)('serviceConfigurationBackupResourceAddBackup', 'serviceId', serviceId);
            // verify required parameter 'serviceType' is not null or undefined
            (0, common_1.assertParamExists)('serviceConfigurationBackupResourceAddBackup', 'serviceType', serviceType);
            const localVarPath = `/services/configurationBackup/{serviceType}/{serviceId}/{configId}`
                .replace(`{${"configId"}}`, encodeURIComponent(String(configId)))
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)))
                .replace(`{${"serviceType"}}`, encodeURIComponent(String(serviceType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ServiceConfigurationBackupApiAxiosParamCreator = ServiceConfigurationBackupApiAxiosParamCreator;
/**
 * ServiceConfigurationBackupApi - functional programming interface
 * @export
 */
const ServiceConfigurationBackupApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ServiceConfigurationBackupApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} configId
         * @param {string} serviceId
         * @param {string} serviceType
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceConfigurationBackupResourceAddBackup(configId, serviceId, serviceType, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serviceConfigurationBackupResourceAddBackup(configId, serviceId, serviceType, body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ServiceConfigurationBackupApi.serviceConfigurationBackupResourceAddBackup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.ServiceConfigurationBackupApiFp = ServiceConfigurationBackupApiFp;
/**
 * ServiceConfigurationBackupApi - factory interface
 * @export
 */
const ServiceConfigurationBackupApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ServiceConfigurationBackupApiFp)(configuration);
    return {
        /**
         *
         * @param {ServiceConfigurationBackupApiServiceConfigurationBackupResourceAddBackupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceConfigurationBackupResourceAddBackup(requestParameters, options) {
            return localVarFp.serviceConfigurationBackupResourceAddBackup(requestParameters.configId, requestParameters.serviceId, requestParameters.serviceType, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ServiceConfigurationBackupApiFactory = ServiceConfigurationBackupApiFactory;
/**
 * ServiceConfigurationBackupApi - object-oriented interface
 * @export
 * @class ServiceConfigurationBackupApi
 * @extends {BaseAPI}
 */
class ServiceConfigurationBackupApi extends base_1.BaseAPI {
    /**
     *
     * @param {ServiceConfigurationBackupApiServiceConfigurationBackupResourceAddBackupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceConfigurationBackupApi
     */
    serviceConfigurationBackupResourceAddBackup(requestParameters, options) {
        return (0, exports.ServiceConfigurationBackupApiFp)(this.configuration).serviceConfigurationBackupResourceAddBackup(requestParameters.configId, requestParameters.serviceId, requestParameters.serviceType, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ServiceConfigurationBackupApi = ServiceConfigurationBackupApi;
//# sourceMappingURL=service-configuration-backup-api.js.map